(function () {
  function hydrateVideo(video) {
    if (!video || video.getAttribute('data-elfink-lazy-ready') === '1') return false;
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return false;
    sources.forEach(function (source) {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
    });
    video.setAttribute('data-elfink-lazy-ready', '1');
    video.load();
    return true;
  }

  function playSafe(video) {
    if (!video) return;
    /* Never download here — only play after hydrate */
    if (video.getAttribute('data-elfink-lazy-ready') !== '1') return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.playsInline = true;
    video.loop = true;
    video.controls = false;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pauseSafe(video) {
    if (!video) return;
    try { video.pause(); } catch (e) {}
  }

  function syncVideos(root) {
    var desktop = root.querySelector('.elfink-tales__slot--desktop video');
    var mobile = root.querySelector('.elfink-tales__slot--mobile video');
    if (!desktop && !mobile) return;

    var mq = window.matchMedia('(min-width: 860px)');

    function apply() {
      var active = mq.matches ? (desktop || mobile) : (mobile || desktop);
      var inactive = mq.matches ? mobile : desktop;

      pauseSafe(inactive);

      /* Only hydrate after section has been near viewport (IO), or editor reload */
      if (root.dataset.etNear === '1' && active) {
        hydrateVideo(active);
        playSafe(active);
      }
    }

    if (!root.dataset.etMqBound) {
      root.dataset.etMqBound = 'true';
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);

      ['touchstart', 'click'].forEach(function (evt) {
        document.addEventListener(evt, function once() {
          apply();
          document.removeEventListener(evt, once, true);
        }, true);
      });
    }

    apply();
  }

  function markNearAndPlay(root) {
    root.dataset.etNear = '1';
    syncVideos(root);
  }

  function observeLazy(root) {
    var media = root.querySelector('.elfink-tales__media');
    if (!media) {
      markNearAndPlay(root);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      markNearAndPlay(root);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        markNearAndPlay(root);
        io.disconnect();
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    io.observe(media);
  }

  function init(root) {
    if (!root || root.dataset.etInit === 'true') return;
    root.dataset.etInit = 'true';
    observeLazy(root);
  }

  function boot() {
    document.querySelectorAll('[data-elfink-tales]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-elfink-tales]')
      : null;
    if (root) {
      root.dataset.etInit = 'false';
      root.dataset.etMqBound = '';
      root.dataset.etNear = '';
      init(root);
    }
  });
})();
